import * as PIXI from 'pixi.js';
import { mediaSourceDimensions } from './MediaSourceDimensionTracker';
import ReactiveMedia from './ReactiveMedia';

export default class ReactiveImage extends ReactiveMedia {
    constructor(stage, zIndex) {
        super(stage, zIndex);
    }

    update(config) {
        // Update the parent settings 
        super.update(config);

        // Load the image texture
        if (this.mediaSource !== config.mediaSource) {
            const imageUrl = config.mediaSource.data.url;
            this.sprite.texture = PIXI.Texture.from(imageUrl);
            this.mediaSource = config.mediaSource;

            const self = this;
            this.sprite.texture.baseTexture.on('loaded', function () {
                // After texture loads, use its dimensions to set the correct aspect ratio.
                const textureWidth = self.sprite.texture.width;
                const textureHeight = self.sprite.texture.height;
                mediaSourceDimensions[imageUrl] = {width: textureWidth, height: textureHeight};
                self.correctAspectRatio(textureWidth, textureHeight);
                self.refreshAfterSourceDimensionsChange();
            });
        }
    }

    draw(spectrum) {
        super.draw(spectrum);
    }

    updateStage(stage) {
        super.updateStage(stage);
    }

    destroy() {
        super.destroy();
    }
}